/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
// import BootstrapVue from 'bootstrap-vue'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import vClickOutside from 'v-click-outside'
import VueAuthImage from 'vue-auth-image';
const VueUploadComponent = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)
import VueSanitize from "vue-sanitize";

import VueParticles from 'vue-particles'
import options from 'vue-countup-directive'
import {
  toSplitNumber,
  toSignNumber
} from "src/utils/string-helper";
import VueRx from 'vue-rx'
import cleave from 'src/utils/directives/cleave-mask';
import VueScreen from 'vue-screen';

Vue.filter('splitNumber', toSplitNumber);
Vue.filter('toSignNumber', toSignNumber);

Vue.use(VueScreen);


Vue.directive('countUp', options)

Vue.directive('cleave', cleave)

Vue.use(VueParticles)

Vue.use(vClickOutside)
Vue.use(Vuesax)
Vue.use(VueRx)
Vue.use(VueAuthImage)
Vue.use(VueSanitize);
// Vue.use(BootstrapVue)

import './assets/landing/style.scss';

// axios
import axios from "./axios.js"
Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import {
  VueHammer
} from 'vue2-hammer'
Vue.use(VueHammer)

import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')



Vue.config.productionTip = false

Vue.prototype.persianRegex = /[\u0600-\u06FF]/

Vue.prototype.captchaInfo = {
  height: "100",
  width: "272",
  red: "0",
  green: "43",
  blue: "153",
}

Vue.prototype.interVals =  new Array();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
